import LaravelEcho from 'laravel-echo';
import CONFIG from '@config';
// eslint-disable-next-line
import Pusher from 'pusher-js';

import { getToken } from '@utils/storage';

export let Echo = null;

export const initializeEcho = () => {
  if (!Echo) {
    const tokenData = getToken();
    if (!tokenData) {
      return Echo;
    }
    Echo = new LaravelEcho({
      broadcaster: 'pusher',
      key: CONFIG.PUSHER_KEY,
      cluster: CONFIG.PUSHER_CLUSTER,
      wsHost: CONFIG.ECHO_HOST,
      wsPort: 80,
      wssPort: 443,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      authEndpoint: CONFIG.ECHO_HOST_AUTH,
      auth: {
        headers: {
          Authorization: `Bearer ${tokenData.token}`,
          Accept: 'application/json',
        },
      },
    });
  }

  return Echo;
};
